/**
 * Page Builder Article Spots
 * 
 * Beinhaltet alle Variablen & Methoden des Article Spots Modules
 * 
 * @since     1.0.0
 * @package   pagebuilder
 */
PageBuilder.ArticleSpots = (function(PageBuilder) { 

  var _hideOverlaysTrigger; 


  /**
   * Article spots. 
   * 
   * Beinhaltet das jQuery Object aller im Dokument verfügbaren Article Spots. 
   * 
   * @since     1.0.0
   * @access    private
   * 
   * @var       {jQuery}
   */
  var $spots;

  /**
   * Init module. 
   * 
   * Initialisiert das Modul nachdem der DOM geladen wurde.
   * 
   * @since     1.0.0
   * @access    private 
   */
  function _init() { 
    // Sanity check
    if ( !$('.page-content .pb-image[data-mapping="article_spots"]').length || $("body").hasClass("view-mobile") ) { 
      return;
    }

    // Spots ermitteln
    $spots = $('.pb-image[data-mapping="article_spots"] .pb-image-map > .article-spot');

    // Event Listener registrieren
    $(window).on('scroll', _hideOverlays );
    $(window).on('resize', _hideOverlays );

    $spots.on('mouseenter', _showOverlay );

    // Spots einblenden sobald Bild geladen wurde
    Array.from(document.querySelectorAll('.pb-image[data-mapping="article_spots"] img[loading="lazy"]')).map(img => { 
      img.addEventListener('load', (e) => { 
        e.target.closest('.pb-image').querySelector('.pb-image-map').setAttribute('style', 'visibility: visible');
      })
    })
  }

  /**
   * Hide overlays. 
   * 
   * Blendet alle aktiven Spot Overlays aus. 
   * 
   * @since     1.0.0
   * @access    private 
   * 
   * @param     {object}  e     HTML DOM Event.
   */
  function _hideOverlays(e) { 
    // Santiy check
    if ( !$('.pb-image[data-mapping="article_spots"] .article-spot.active').length ) { 
      return;
    }

    // Spot Status zurücksetzten
    $spots.removeClass('active');
    
    // Spot Overlays entfernen
    $('.page-content > .pb-article-spot-overlay').each(function(){
      $(this).off('mouseleave');
      $(this).remove()
    });
  }

  /**
   * Show overlay. 
   * 
   * Ermittelt die Position des Spots und blendet das Overlay des Spots ein.
   * 
   * @since     1.0.0
   * @access    private 
   * 
   * @param     {object}    e     HTML DOM Event.
   */
  function _showOverlay(e) { 
    // Sanity check
    if ( $(this).closest('.article-spot').hasClass('active') ) { 
      return;
    }

    // Vorhandene Overlays ausblenden
    _hideOverlays();

    // Overlay Position ermitteln
    var $spot = $(this).closest('.article-spot'),
        tmpOverlayAlign = _getSpotOverlayAlign( $spot ), 
        tmpOverlayPosition = _getSpotOverlayPosition( $spot, tmpOverlayAlign );

    // Overlay vorbereiten
    var $tmpOverlay = $(
      '<div id="tmp-pb-article-spot-overlay-' + Date.now() + '" class="pb-article-spot-overlay">' + 
        '<div class="pb-article-spot-overlay-inner align-' + tmpOverlayAlign.x + '">' +
          '<div class="pb-article-spot-overlay-arrow"></div>' + 
          '<div class="pb-article-spot-overlay-content">' + $spot.find('.spot-overlay').html() + '</div>' + 
        '</div>' + 
      '</div>'
    ).css( tmpOverlayPosition );

    // Overlay einfügen & ausspielen
    $tmpOverlay.appendTo('.page-content').fadeIn( 100, function() {
      // Spot als aktiv markieren
      $spot.addClass('active');
      // Leave Event einbinden
      $(this).one('mouseleave', function(e){ 
        _hideOverlays();
      })
    })
  }

  /**
   * Get spot overlay align. 
   * 
   * Ermittelt die erforderliche Ausrichtung des Overlays an Hand der Spot Position. 
   * 
   * @since     1.1.0
   * @access    private 
   * 
   * @param     {jQuery}    $spot     jQuery DOM Node. 
   * 
   * 
   * @returns   {object}
   */
  function _getSpotOverlayAlign( $spot ) { 
    var c = $spot.find('.spot-icon-circle')[0].getBoundingClientRect(),
        d = document.documentElement;

    return { 
      x: _determineOverlayAlignHorizontal({ 
        x: c.left + c.width / 2,
        width: 250 + 30, 
        widthAvailable: d.clientWidth || window.innerWidth
      }),
      y: _determineOverlayAlignVertical({
        y: c.top + c.height / 2,
        height: $spot.find('.spot-overlay').outerHeight() / 2 + 30, 
        heightAvailable: d.clientHeight || window.innerHeight
      })
    };
  }

  /**
   * Get spot overlay position. 
   * 
   * Ermittelt die absolute Position des Spot Overlays innerhalb der Seite. 
   * 
   * @since     1.1.0
   * @access    private
   * 
   * @param     {jQuery}    $spot     jQuery DOM Node.  
   * @param     {object}    algin     Overlay Ausrichtung.
   * @returns 
   */
  function _getSpotOverlayPosition( $spot, overlayAlign ) { 
    var spotOffset = $spot.offset(),
        overlay = { width: 250, height: $spot.find('.spot-overlay').outerHeight() };

    return { 
      top:  spotOffset.top - overlay.height / 2,
      left: overlayAlign.x === 'right' ? spotOffset.left - 5 : spotOffset.left - overlay.width - 10 + 5
    }
  }

  /**
   * Determine overlay align horizontal 
   * 
   * Horizontale Ausrichtung des Overlays bestimmen.
   * 
   * @since     1.0.0
   * @access    private
   *  
   * @param     {object}    args      Overlay Eigenschafen.
   * 
   * @return    {string}    Horizontale Postion
   */
  function _determineOverlayAlignHorizontal( args ) {
    return args.x + args.width > args.widthAvailable ? 'left' : 'right'
  }

  /**
   * Determine overlay align vertical 
   * 
   * Vertikale Ausrichtung des Overlays bestimmen
   * 
   * @since     1.0.0
   * @access    private 
   * 
   * @param     {object}    args     Overlay Eigenschaften.
   * 
   * @return    {string}    Vertikale Position 
   */
  function _determineOverlayAlignVertical( args ) {
    return args.y - args.height < 0 ? 'top' : args.y + args.height > args.heightAvailable ? 'bottom' : 'center'
  }

  /**
   * Application Module  
   * 
   * Public Scope des Modules das alle nach außen verfügbaren Variablen & Methoden bereit stellt. 
   * 
   * @since     1.0.0
   * @access    public
   */
  var _self = { 
  }

  // Self-init
  if ( document.readyState === "complete" || ( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
    _init() 
  } else {
    document.addEventListener( "DOMContentLoaded", _init );
  }

  return _self;

})( PageBuilder || {} );